<template>
  <div class="container">
    <div class="weui-msg" v-if="isNoneData">
        <div class="weui-msg__icon-area"><i class="weui-icon-success weui-icon_msg"></i></div>
        <div class="weui-msg__text-area">
            <h2 class="weui-msg__title">注册成功</h2>
            <p class="weui-msg__desc">欢迎使用到家，点击下方按钮立刻使用我们的服务</p>
        </div>
        <div class="btn-box">
          <div class="btn active" @click="goto('/')">立即预约服务</div>
        </div>
    </div>

    <div class="weui-msg"  v-if="!isNoneData">
        <div class="weui-msg__icon-area"><i class="weui-icon-success weui-icon_msg"></i></div>
        <div class="weui-msg__text-area">
            <h2 class="weui-msg__title">注册成功</h2>
            <p class="weui-msg__desc">您有未完成的订单，点击下方按钮立即继续</p>
        </div>
        <div class="btn-box">
          <div class="btn active" @click="goto('/move-step1')" v-show="isMoveData">继续完成搬家订单</div>
          <div class="btn active" @click="goto('/move-step1')" v-show="isCleanData">继续完成清洁订单</div>
        </div>
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'reg-success',
  data () {
    return {
      isMoveData:false,
      isCleanData:false,
      isNoneData:true,
      order:{}
    }
  },
  created: function () {
    if (localStorage.hasOwnProperty('savedMove')){
      this.isMoveData = true;
    }
    if (localStorage.hasOwnProperty('savedClean')){
      this.isCleanData = true;
    }
    if(this.isMoveData || this.isCleanData){
      this.isNoneData = false;
    }
  },
  methods: {
    isNoneData(){

    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";
.container{
  padding-top:30px;
}

.container /deep/{
  .weui-icon-success{
    color:#fe9567;
  }
  .weui-btn_primary{
    background:#fe9567;
    color:#fff;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/user/reg-success.vue